/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

/**
 * Returns a function that rerenders the component
 * when it gets called.
 */
export const useForceRender = () => {
    const [, setCounter] = React.useState(0);

    return React.useCallback(() => setCounter(c => c + 1), []);
};
